import store from '@/store'
import { useGtm } from "vue-gtm"
import router from '@/router'

export default function useCancellation() {
  const gtm = useGtm()
  const user = store.getters['user/user']
  const subscription = store.getters['subscription/subscription']

  function goBackFromCancellation ({ type }) {
    trackCancellationRecovered({ type })

    router.replace('/')
  }

  function trackCancellationRecovered ({ type }) {
    gtm.trackEvent({
      event: 'cancellation.recovered',
      user_id: user.id,
      type,
    })
  }

  function trackCancellationFeedbackOnAnlytics ({ reasons, feedback }) {
    for (const reason of reasons) {
      gtm.trackEvent({
        event: 'cancellation.reason',
        reason,
        user_id: user.id
      })
    }

    gtm.trackEvent({
      event: 'cancellation',
      type: 'subscription',
      plan_id: subscription.plan.id,
      user_id: user.id
    })

    gtm.trackEvent({
      event: 'cancellation.feedback',
      user_id: user.id,
      feedback,
    })
  }

  return {
    trackCancellationFeedbackOnAnlytics,
    trackCancellationRecovered,
    goBackFromCancellation,
  }
}